<template>
  <Transition name="toast">
    <div
      v-if="visible"
      class="fixed top-[20px] left-1/2 -translate-x-1/2 z-[9999] max-w-max px-[16px] py-[10px] rounded-[4px] flex items-center gap-[10px] border"
      :class="typeClass"
      :style="boxShadow"
    >
      <div class="flex-shrink-0">
        <!-- Success Icon -->
        <svg
          v-if="type === 'success'"
          class="w-[16px] h-[16px]"
          viewBox="0 0 1024 1024"
          fill="currentColor"
        >
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
          />
        </svg>

        <!-- Error Icon -->
        <svg
          v-else-if="type === 'error'"
          class="w-[16px] h-[16px]"
          viewBox="0 0 1024 1024"
          fill="currentColor"
        >
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"
          />
        </svg>

        <!-- Warning Icon -->
        <svg
          v-else-if="type === 'warning'"
          class="w-[16px] h-[16px]"
          viewBox="0 0 1024 1024"
          fill="currentColor"
        >
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
          />
        </svg>

        <!-- Info Icon -->
        <svg
          v-else
          class="w-[16px] h-[16px]"
          viewBox="0 0 1024 1024"
          fill="currentColor"
        >
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
          />
        </svg>
      </div>

      <div class="flex-1 text-[14px] leading-[20px]">
        {{ message }}
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = defineProps<{
  message: string
  type?: 'success' | 'error' | 'warning' | 'info'
  duration?: number
}>()

const visible = ref(true)

// Element Plus Message 样式配色
const typeClass = computed(() => {
  switch (props.type) {
    case 'success':
      return 'bg-[#f0f9ff] text-[#67c23a] border-[#e1f3d8]'
    case 'error':
      return 'bg-[#fef0f0] text-[#f56c6c] border-[#fde2e2]'
    case 'warning':
      return 'bg-[#fdf6ec] text-[#e6a23c] border-[#faecd8]'
    default:
      return 'bg-[#f4f4f5] text-[#909399] border-[#e9e9eb]'
  }
})

// Element Plus Message 阴影样式
const boxShadow = computed(() => {
  return {
    boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
  }
})

onMounted(() => {
  setTimeout(() => {
    visible.value = false
  }, props.duration || 3000)
})
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translate(-50%, -20px);
}

.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>
